import React from "react";

const AdminWalletICon = ({ width, height, color }) => {
  return (
    <svg
      width="32"
      height="30"
      viewBox="0 0 32 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6917 10.4773H29.3332C29.3332 6.23074 26.6191 3.75 22.0206 3.75H9.9791C5.38058 3.75 2.6665 6.23074 2.6665 10.4231V19.5769C2.6665 23.7693 5.38058 26.25 9.9791 26.25H22.0206C26.6191 26.25 29.3332 23.7693 29.3332 19.5769V19.1869H23.6917C21.0735 19.1869 18.9509 17.2469 18.9509 14.8538C18.9509 12.4606 21.0735 10.5206 23.6917 10.5206V10.4773ZM23.6917 12.3405H28.3376C28.8874 12.3405 29.3332 12.7479 29.3332 13.2505V16.4137C29.3268 16.9138 28.8848 17.3178 28.3376 17.3237H23.7984C22.4729 17.34 21.3138 16.5105 21.0132 15.3304C20.8626 14.5979 21.074 13.842 21.5906 13.2653C22.1072 12.6886 22.8763 12.3501 23.6917 12.3405ZM23.8932 15.6662H24.3317C24.8946 15.6662 25.3509 15.2491 25.3509 14.7346C25.3509 14.2201 24.8946 13.803 24.3317 13.803H23.8932C23.6239 13.8001 23.3646 13.8958 23.1732 14.0688C22.9817 14.2418 22.8739 14.4777 22.8739 14.7238C22.8739 15.2401 23.3283 15.6603 23.8932 15.6662ZM8.98354 10.4773H16.5095C17.0724 10.4773 17.5287 10.0601 17.5287 9.54562C17.5287 9.03109 17.0724 8.61399 16.5095 8.61399H8.98354C8.42522 8.61395 7.97077 9.0245 7.96428 9.53479C7.96424 10.0511 8.41871 10.4713 8.98354 10.4773Z"
        fill="#D9D9D9"
      />
    </svg>
  );
};

export default AdminWalletICon;
